import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import Row from '../../../../../../common/atoms/Row';
import Anchor from '../../../../../../common/atoms/Anchor';
import Image from '../../../../../../common/atoms/Image';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles from './PaymentOverviewTileNew.style';
import internalEndpoints from '../../../internalEndpoints';
import { getIconPath } from '../../../../../../../utils';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import AccountCommonLabels, { GLOBAL_LABELS } from '../../../labels/AccountCommon.labels';

const PaymentOverviewTileNew = (props) => {
  const globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, AccountCommonLabels);

  const { children, className } = props;

  return (
    <div className={`${className} payment-tile-wrapper`}>
      <BodyCopy component="div" className="payment-tile-heading">
        <div className="payment-tile-heading-left">
          <Image
            src={`${getIconPath('gift-card-icon-small')}`}
            alt={'Payment And Gift Icon'}
            className="payment-and-gift-icon"
          />
          <span className="payment-tile-heading-text">
            {renderLabel(
              globalLabels?.accountDrawer?.lbl_accoundDashboard_paymentGiftCards,
              'lbl_accoundDashboard_paymentGiftCards'
            )}
          </span>
        </div>
        <Anchor
          to={internalEndpoints.paymentPage.link}
          asPath={internalEndpoints.paymentPage.path}
          className="payment-tile-view-all"
          target={'_self'}
          dataLocator={'accountverview-paymentTitle-viewallcta'}
          useRouterNavigation
        >
          {renderLabel(globalLabels?.cartItemTile?.lbl_view_all, 'lbl_view_all')}
        </Anchor>
      </BodyCopy>
      <Row fullBleed className="payment-tile-main">
        {children}
      </Row>
    </div>
  );
};

PaymentOverviewTileNew.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

PaymentOverviewTileNew.defaultProps = {
  className: '',
};
export default withStyles(PaymentOverviewTileNew, styles);
export { PaymentOverviewTileNew as PaymentOverviewTileNewVanilla };
